import type { ImageUrls } from '../utils/imageUpload';

export type { ImageUrls };

export enum NewsCategory {
  NEWS = 'news',
  EVENTS = 'events',
  UPDATES = 'updates',
}

export type TextElement = {
  id: string;
  type: 'text';
  hasSubtitle: boolean;
  subtitle: string;
  text: string;
};

export type LinkElement = {
  id: string;
  type: 'link';
  linkDescription: string;
  url: string;
  showedText: string;
};

export type ImageElement = {
  id: string;
  type: 'image';
  urls: ImageUrls | null;
  uploading: boolean;
};

export type ContentElement = TextElement | LinkElement | ImageElement;

export type PublishState =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'success' }
  | { status: 'error'; message: string };
